import type { InfiniteScroll } from "../../../../lib/pagination";
import type { CorpusFeed, CorpusFeedStatisticsByFeed } from "@shared/types/corpus/api.ts";
import { InfiniteGrid } from "../../../primitives/data-display/InfiniteGrid";
import { FeedCard } from "../FeedCard";

/** What is known of the feeds' statistics: those that have arrived, and the feeds whose could not
 *  be loaded. */
export interface FeedStatisticsLookup {
  byFeed: CorpusFeedStatisticsByFeed;
  unavailable: ReadonlySet<string>;
}

interface FeedGridProps {
  feeds: CorpusFeed[];
  statistics: FeedStatisticsLookup;
  /** Where a feed's card leads. */
  getFeedHref: (feed: CorpusFeed) => string;
  scroll: InfiniteScroll;
}

/** Corpus feeds as cards in a grid that goes on loading as the reader scrolls. */
export function FeedGrid({ feeds, statistics, getFeedHref, scroll }: FeedGridProps) {
  return (
    <InfiniteGrid
      items={feeds}
      getKey={(feed) => feed.id}
      scroll={scroll}
      renderItem={(feed) => (
        <FeedCard
          feed={feed}
          to={getFeedHref(feed)}
          statistics={statistics.byFeed[feed.id]}
          statisticsUnavailable={statistics.unavailable.has(feed.id)}
        />
      )}
    />
  );
}
